import { ReactNode, RefObject } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

export type SectionTitleProps = {
  children: ReactNode;
  classNames?: string;
  shouldRenderAsH1Heading?: boolean;
  elementRef?: RefObject<HTMLHeadingElement>;
};
export const SectionTitle = ({
  children,
  classNames,
  elementRef,
  shouldRenderAsH1Heading = false,
}: SectionTitleProps) => {
  if (shouldRenderAsH1Heading) {
    return (
      <h1 ref={elementRef} className={clsx(styles.sectionTitle, classNames)}>
        {children}
      </h1>
    );
  }

  return (
    <h2 ref={elementRef} className={clsx(styles.sectionTitle, classNames)}>
      {children}
    </h2>
  );
};
